import {call, put, takeLatest} from 'redux-saga/effects'
import {api} from '~/services/api'
import {getProcessHashChipPoolFailed, getProcessHashChipPoolSuccess, GET_PROCESS_HASH_CHIP_POOL_START} from "~/views/app/redux/actions/pools";

/**
 * get list notification api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getHashChipRedeemedProcessApi = (props) => {
  return api.get(`/admin/hash-chip-redeemed/process`, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetHashChipRedeemedProcess(action) {
  try {
    const response = yield call(getHashChipRedeemedProcessApi, action?.payload)
    yield put(getProcessHashChipPoolSuccess(response))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(getProcessHashChipPoolFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list process hash chip
 */
export default function* watchGetHashChipRedeemedProcess() {
  yield takeLatest(GET_PROCESS_HASH_CHIP_POOL_START, doGetHashChipRedeemedProcess)
}
